import { useCallback } from 'react';
import './style.scoped.css';
import TextInput from 'src/components/TextInput';
import { useTranslation } from 'react-i18next';
import { formatMoney, paymentCheckDot, validateTopUpFee } from 'src/utils';
import paymentSt, { PaymentStore } from 'src/stores/PaymentStore';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

interface TopUpObserverProps {
  paymentStore?: PaymentStore;
}

const TopUpObserver = observer(({
  paymentStore
} : TopUpObserverProps) => {
  const { t } = useTranslation();

  const _handleChange = useCallback((event) => {
    let value = event.target.value;
    value = value?.trim();
    if(value){
      let num = Number(value);
      if(!Number.isNaN(num) && !paymentCheckDot(value)){
        let min = Number(paymentStore?.topUpPaymentInfo?.topUpMinAmt);
        let max = Number(paymentStore?.topUpPaymentInfo?.topUpMaxAmt);
        let validate = validateTopUpFee(num, min, max);
        paymentStore.updateTopUpPaymentInfo({
          topUpValue: value,
          errTopUpValue: !validate ? 'error' : '',
          topUpValueInput: value,
          topUpValueFormat: formatMoney(value) + ' ' + paymentStore?.topUpPaymentInfo?.currency,
          amount: Number(value)
        });
      }
    }else{
      paymentStore.updateTopUpPaymentInfo({
        topUpValue: '',
        errTopUpValue: '',
        topUpValueInput: '',
        topUpValueFormat: '',
        amount: 0
      });
    }
  }, [paymentStore]);

  const _handleBlur = useCallback(() => {
    paymentStore.updateTopUpPaymentInfo({
      topUpValueInput: paymentStore?.topUpPaymentInfo?.topUpValueFormat,
    });
  }, [paymentStore]);

  const _handleFocus = useCallback(() => {
    paymentStore.updateTopUpPaymentInfo({
      topUpValueInput: paymentStore?.topUpPaymentInfo?.topUpValue,
    });
  }, [paymentStore]);

  return (
    <div className="view-top-up">
      <div>
        <div className='bg-surface'>
          <div className="text-base font-bold text-onSurface px-4 pt-4">
            {t('additional_insurance_fee')}
          </div>
          <div className="px-4 pt-2 pb-4 bodyText2 text-onSurfaceVariant border border-line">{t('hint_additional_insurance_fee')}</div>
        </div>

        <div className='bg-surface mb-8'>
          {/* <Checkbox
            textComponent={
              <div>
                <div className="text-base font-bold text-onSurface">
                {t('additional_insurance_fee')}
                </div>
                <div className="bodyText2 text-onSurfaceVariant">{t('hint_additional_insurance_fee')}</div>
              </div>
            }
            checked={true}
            onCheck={() => {}}
            changeBackground={false}
            type="card"
          /> */}
          <div className="px-4 pb-6 pt-5">
            <TextInput
              label={t('topup_fee_hint')}
              placeholder={''}
              value={paymentStore?.topUpPaymentInfo?.topUpValueInput}
              onChange={_handleChange}
              onBlur={_handleBlur}
              onFocus={_handleFocus}
              type={'text'}
              helperText={
                paymentStore?.topUpPaymentInfo?.disabledInput
                ? `${t('top_up_input_disabled_hint')}`
                : `${t('min')} ${formatMoney(paymentStore?.topUpPaymentInfo?.topUpMinAmt)} ${paymentStore?.topUpPaymentInfo?.currency}; ${t('max')} ${formatMoney(paymentStore?.topUpPaymentInfo?.topUpMaxAmt)} ${paymentStore?.topUpPaymentInfo?.currency}`
              }
              disabled={paymentStore?.topUpPaymentInfo?.disabledInput}
            />
            {!!paymentStore?.topUpPaymentInfo?.errTopUpValue && (
              <div className={'helperTextError'}>{t('msg_09')}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

const TopUp = () => <TopUpObserver paymentStore={paymentSt} />;
export default TopUp;
